import Template from "@/components/Navbar/Profile/Profile.template.vue";
import { i18n } from "@/plugins/i18n";
import { traceabilityService } from "@/services/traceability.service";
import { User } from "@/vuex/auth/types";
import { Component, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";

const namespace = "authModule";

@Component({
  mixins: [Template]
})
export default class ProfileComponent extends Vue {
  public profileMenu: boolean = false;
  @Getter("isLogged", { namespace }) public isLogged!: string;
  @Getter("user", { namespace })
  public user!: User;
  @Action("logout", { namespace }) public logoutAction!: Function;

  public showImage = true;
  public validCreds!: boolean;
  public renderTraceAlert: boolean = false;

  public notifications: object[] = [
    // {
    //   id: 1,
    //   user: "Shannon Young",
    //   avatar: "img1.jpg",
    //   msg:
    //     "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    // }
  ];

  public displayMenu() {
    this.profileMenu = !this.profileMenu;
  }

  public modifyCreds() {
    window.location.href = `${
      process.env.VUE_APP_CORE_FRONTEND
    }/application-management/profile`;
  }

  public async mounted() {
    const locationId = this.user.settings!.current_location_id;
    const tracestatus = await traceabilityService.validateUserCredentials();
    this.validCreds =
      tracestatus.status === "error" || tracestatus.code === 200 ? true : false;
    await traceabilityService
      .getCurrentTraceability({ location_id: locationId })
      .then(response => {
        if (response[0].value === "Biotrack Traceability" && !this.validCreds) {
          this.renderTraceAlert = true;
        }
      });
  }

  public imgError() {
    this.showImage = false;
  }

  public logout() {
    this.logoutAction();
  }
}
